import { useEffect, useState } from 'react'
import useFilterStore from 'stores/useFilterStore'
import { FilterEmployeeName } from 'types/referrals'
import type { Filter, UseFilter } from 'types/table'
import useFilterPaymentStore from './useFilterPaymentStore'

export default function useFilter() {
  const { filters, onAddFilter, onCleanFilters } = useFilterPaymentStore()
  const { onCloseAnchor } = useFilterStore()

  const [filterPayment, setFilterPayment] = useState({
    status: [] as Array<UseFilter>,
    joined: [] as Array<UseFilter>
  })

  useEffect(() => {
    const filterEntries = Object.entries(filters)
      .map(([key, value]) => {
        return {
          key: Array.isArray(value) && value.length > 0 ? key : null,
          value: JSON.parse(JSON.stringify(value)) as Array<string>
        }
      })
      .filter(item => item.key)

    filterEntries.map(item => {
      setFilterPayment(prevState => {
        return {
          ...prevState,
          [item.key as FilterEmployeeName]: item.value.map(item => {
            return {
              id: item,
              label: item,
              checked: true
            }
          })
        }
      })
    })
  }, [JSON.stringify(filters)])

  const onClearFilters = (name: FilterEmployeeName) => {
    onCleanFilters(name)
    onCloseAnchor()
  }

  const onAddUrlFilters = (name: FilterEmployeeName) => {
    onAddFilter(filterPayment[name], name)
    onCloseAnchor()
  }

  const onChangeValue = ({
    filter,
    name
  }: {
    filter: Filter
    name: 'status' | 'joined'
  }) => {
    setFilterPayment(prevState => {
      if (!filter.checked) {
        return {
          ...prevState,
          [name]: [...prevState[name].filter(item => item.id !== filter.id)]
        }
      }
      return {
        ...prevState,
        [name]: [
          ...prevState[name].filter(item => item.id !== filter.id),
          filter
        ]
      }
    })
  }

  return {
    onChangeValue,
    onClearFilters,
    onAddUrlFilters,
    filterPayment
  }
}
